import useInTrainingPilot from '@rover/react-lib/src/pages/training/hooks/useInTrainingPilot';
import useCountryConfigurationShim from '@rover/shared/js/hooks/useCountryConfigurationShim';

const useShouldShowDogTrainingCard = (): boolean => {
  const { shouldShowTrainingEntrypoints } = useInTrainingPilot();
  const { navigation } = useCountryConfigurationShim();
  return shouldShowTrainingEntrypoints && (navigation?.hasDogTraining ?? false);
};

export default useShouldShowDogTrainingCard;
